import type { GivingTypeEnum, LabelInValue } from 'models';
import { Col, EntitySnippet, Form, Input, Row, Select } from 'ui';
import { images } from 'common/utils';
import { useUser } from 'features/auth';
import { OrganizationSelect } from 'features/organizations';
import { useGivingTypeOptions } from '../../../hooks';

export type GivingsListFiltersFormValues = {
  organization?: LabelInValue;
  search?: string;
  type?: 'all' | GivingTypeEnum;
};

const GivingsListFilters = () => {
  const { getOptionsBasedOnPermissions } = useGivingTypeOptions();
  const { railsUserData: viewer } = useUser();

  return (
    <Row gutter="ms">
      <Col flex="1">
        <Form.Item<GivingsListFiltersFormValues> label="Search" name="search">
          <Input hasSearch />
        </Form.Item>
      </Col>
      {(viewer.membershipsCount.joinedOrganizations ?? 0) > 1 ? (
        <Col flex="1">
          <Form.Item<GivingsListFiltersFormValues> label="Organization" name="organization">
            <OrganizationSelect<LabelInValue>
              allowClear
              createOption={(organization) => ({
                label: (
                  <EntitySnippet
                    avatarProps={{
                      fallbackPhoto: images.default.organizationProfilePhoto,
                      size: 'sm',
                      src: organization.squareLogo ?? organization.profilePhoto,
                    }}
                    titleProps={{ children: organization.name }}
                  />
                ),
                value: organization.id,
              })}
              query={{ filter: { scope: 'joined' } }}
            />
          </Form.Item>
        </Col>
      ) : null}
      <Col flex="1">
        <Form.Item<GivingsListFiltersFormValues> label="Type" name="type">
          <Select options={getOptionsBasedOnPermissions()} />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default GivingsListFilters;
